/**
 * 工具箱相关API
 */
import http from './http'

export default class ToolkitApi {
    constructor(namespace) {
        this.namespace = namespace;
    }

    start(params) {
        return http.httpPost(this.namespace + '/start', params);
    }

    getProgress(token) {
        return http.httpGet(this.namespace + '/progress', {token});
    }

    getList(token, params) {
        return http.httpGet(this.namespace + '/list', {token, ...params});
    }

    cancel(token) {
        return http.httpPost(this.namespace + '/cancel', {token});
    }

    downloadReport(params = {}) {
        let param = '', count = 0;
        for (let item in params) {
            param += (count === 0 ? '?' : '&') + item + '=' + params[item];
            count++;
        }
        return http.getBaseUrl() + '/' + this.namespace + '/downloadReport' + param;
    }
}



// WEBPACK FOOTER //
// ./app/api/toolkit.api.js